const appConfig = {
  "name": "sponsored-accounts-v2-main",
  "version": "0.1.0",
  "stage": "dev",
  "deployThisBuild": false,
  "okta": {
    "issuer": "https://okta.mit.edu/oauth2/aus6shg1319alZcDf697",
    "clientId": "ndslvmutjuf57q6cearm5an03",
    "redirectUris": [
      "https://sponsored-accounts-v2.atlas-apps-dev.mit.edu"
    ],
    "postLogoutRedirectUris": [
      "https://sponsored-accounts-v2.atlas-apps-dev.mit.edu/logout"
    ],
    "scopes": [
      "address",
      "digital-id/search",
      "digital-id/user",
      "email",
      "feature/user",
      "offline_access",
      "openid",
      "phone",
      "profile",
      "user/all",
      "user/finance"
    ]
  },
  "amplify": {
    "userPoolId": "us-east-1_14cFcpuS8",
    "userPoolWebClientId": "ndslvmutjuf57q6cearm5an03",
    "oauth": {
      "domain": "atlas-auth-dev.mit.edu",
      "scope": [
        "digital-id/search",
        "digital-id/user",
        "feature/user",
        "openid",
        "profile",
        "user/action.admin-account",
        "user/all",
        "user/finance"
      ],
      "redirectUris": [
        "https://sponsored-accounts-v2.atlas-apps-dev.mit.edu"
      ],
      "postLogoutRedirectUris": [
        "https://sponsored-accounts-v2.atlas-apps-dev.mit.edu/logout"
      ],
      "responseType": "token",
      "options": {
        "AdvancedSecurityDataCollectionFlag": false
      }
    }
  }
};
export default appConfig;